import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRedhatComponent } from './simple-icons-redhat.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRedhatComponent ],
    exports:      [ SimpleIconsRedhatComponent ],
    bootstrap:    []
})
export class SimpleIconsRedhatModule {}
